import { render, staticRenderFns } from "./NaloziZaSluzbenoPutovanje.vue?vue&type=template&id=1d513956&scoped=true&"
import script from "./NaloziZaSluzbenoPutovanje.vue?vue&type=script&lang=ts&"
export * from "./NaloziZaSluzbenoPutovanje.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d513956",
  null
  
)

export default component.exports